import * as React from 'react'
import styles from './SidebarTip.sass'

/**
 * Sidebar Tip
 */
export default function SidebarTip() {
  return (
    <div className={styles.root}>
      <div className={styles.box}>
        <div className={styles.content}>
          <img
            className={styles.illustration}
            src={require('assets/images/img_manage-billing.svg')}
            alt="Two hands exchanging a coin"
          />
          <h1 className={styles.title}>Track your earnings</h1>
          <p className={styles.description}>
            We’re making improvements to provide insights into your earnings on
            the platform.
          </p>
        </div>
      </div>
    </div>
  )
}
